module.exports = __webpack_public_path__ + "img/SO.deed03a9.svg";